import { render, staticRenderFns } from "./CitasMedicasView.vue?vue&type=template&id=db70bdb8"
import script from "./CitasMedicasView.vue?vue&type=script&lang=js"
export * from "./CitasMedicasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports